const highlights = [
    {
      title: "Perfect Parry or Pure Luck?",
      url: "https://www.youtube.com/embed/dQw4w9WgXcQ"
    },
    {
      title: "Carmen Solves the Unsolvable",
      url: "https://www.youtube.com/embed/oHg5SJYRHA0"
    },
    {
      title: "GlitchDad’s Retro Breakdown",
      url: "https://www.youtube.com/embed/tgbNymZ7vqY"
    }
  ];
  
  export default highlights;
  